var map = {
	"./box.svg": "21a9",
	"./box_active.svg": "8c37",
	"./settings.svg": "4aa0",
	"./settings_active.svg": "2d50",
	"./shop.svg": "8912",
	"./shop_active.svg": "240a",
	"./shopping-cart-1.svg": "36af",
	"./shopping-list.svg": "d735",
	"./sym-cart-01.svg": "36f1",
	"./sym-noti-01.svg": "cc91",
	"./sym-order-02.svg": "0c39",
	"./sym-report-01.svg": "9d07"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a562";